/**
 * @file freePool.ts
 * @brief The words for Free's ONE pool of minutes, shared by Super Admin →
 *        Plans & seats and the user's Billing → Plan (web + Mac app)
 *
 * @details
 * W34 (DES 31-10-2026): "What's included" read as if Free's 300 minutes were
 * Meeting Notes only. Since B43 (ADR-061) they are one pool for Meeting Notes,
 * Full Intelligence and voice notes, never charged. First row "Free minutes:
 * 300, once, for everything" with the sub-line below, then each product says
 * "From the free minutes". FREE_INTEL_MAX_MINUTES below the pool caps the
 * Full part: "Up to N of them". The WEBSITE uses the same words (contract in
 * the W34 report). Pure (no imports) so node:test can load it.
 *
 * @author DES (prepared with Claude)
 * @date 31-10-2026
 */

export const FREE_POOL_LABEL = "Free minutes";
export const FREE_POOL_SUB = "Meeting Notes, Full Intelligence and voice notes all use these minutes";
export const FROM_FREE_MINUTES = "From the free minutes";

const whole = (n: number) => n.toLocaleString("en-GB");

/** "300, once, for everything" / "600 / month, for everything"; null when unknown. */
export function freePoolValue(minutes: number | null | undefined, once: boolean): string | null {
  if (minutes == null || !Number.isFinite(minutes)) return null;
  return `${whole(minutes)}${once ? ", once" : " / month"}, for everything`;
}

/**
 * The Meeting Intelligence row on Free: "From the free minutes", "Up to 120
 * of them" when FREE_INTEL_MAX_MINUTES is below the pool, "Not on Free" at 0.
 * No cap sent (null) = the whole pool.
 */
export function freeIntelValue(intelMax: number | null | undefined, pool: number | null | undefined): string {
  if (intelMax == null || !Number.isFinite(intelMax)) return FROM_FREE_MINUTES;
  if (intelMax <= 0) return "Not on Free";
  if (pool != null && Number.isFinite(pool) && intelMax >= pool) return FROM_FREE_MINUTES;
  return `Up to ${whole(intelMax)} of them`;
}
